import React, { useState, useEffect, useMemo } from "react";
import { UploadOutlined } from "@ant-design/icons";
import {
  Form,
  Input,
  Upload,
  Select,
  Modal,
  Button,
  Space,
  Row,
  Col,
  DatePicker,
  Table,
  InputNumber,
  Tooltip,
  Divider,
  Collapse,
  TimePicker,
  Switch,
  Input as AntInput,
} from "antd";

import { debounce } from 'lodash';
import {
  MinusCircleOutlined, PlusOutlined, CaretUpOutlined,    // ✅ Add this
  CaretDownOutlined
} from "@ant-design/icons";
import dayjs from "dayjs";
import { apiRequest } from "../../../../service/apiRequest";
import { showSuccess, showError } from "../../../../components/errorHandler";
// import type {
//     CompanyName,
// } from '../../../../types/CompanyName';
import type { UploadFile } from 'antd/es/upload/interface';
import type {
  Pn,
  Categories,
  BrandNames,
  City,
  State,
  Country,
} from "../../../../types/CreateProductType";

import type { SelectProps } from 'antd';

import type { ColumnsType } from 'antd/es/table';

import duration from 'dayjs/plugin/duration';
import { Dayjs } from "dayjs";

import customParseFormat from 'dayjs/plugin/customParseFormat';
import DesignationModel from "../../ledger-mastes/designations/DesignationModal";
import OccupationModal from "../../ledger-mastes/occupations/OccupationModal";
import CityModal from "../../masters/location-masters/cities/CityModal";
import CountryModal from "../../masters/location-masters/countries/CountryModal";
import StateModal from "../../masters/location-masters/states/StateModal";
import BrandNameModel from "../../masters/brand-names/BrandNameModel";
import GstTypeModal from "../../ledger-mastes/gst-types/GstTypelModal";

dayjs.extend(customParseFormat);

const { Option } = Select;

const { Panel } = Collapse;

const MSME_REGEX = /^UDYAM-[A-Z]{2}-\d{2}-\d{7}$/;


const dateFormatList = ['DD/MM/YYYY', 'DD/MM/YY', 'DD-MM-YYYY', 'DD-MM-YY'];


const { TextArea } = Input;
dayjs.extend(duration);

interface AccountHead {
  ah_id: number;
  ah_name: string;
  ah_parent: number;

}
interface SubHead {
  ah_id: number;
  ah_name: string;
}
interface LinkItem {
  link: string;
  description?: string;
  link_name?: string;
  link_url?: string;
}
interface BankItem {
  bank_name: string;
  ifsc: string;
  acc_no: string;
  address?: string;
  holder_name?: string;
  bank_account_account_no?: string;
  bank_account_bank_address?: string;
  bank_account_branch_name?: string;
  bank_account_holder_name?: string;
  bank_account_ifsc?: string;
}
interface AddressItem {
  type?: "residence" | "office";
  address?: string;
  landmark?: string;
  pincode?: string;
  city?: string;
  state?: string;
  country?: string;
  address_type?: "residence" | "office";
  address_detail?: string;
  address_landmark?: string;
  address_pincode?: string;
  address_city?: string;
  address_state?: string;
  address_country?: string;
}

interface PayrollItem {
  payroll_id?: number;
  payroll_ledger_id?: number;

  payroll_check_in?: string | Dayjs | null;
  payroll_check_out?: string | Dayjs | null;
  payroll_working_hours?: string;
  payroll_lunch_in?: string | Dayjs | null;
  payroll_lunch_out?: string | Dayjs | null;
  payroll_days_of_working?: string | string[] | null | undefined;
  payroll_days_off?: string | string[] | null | undefined;
  payroll_date_of_joining?: string | Dayjs | null;

  payroll_salary?: number | null;

  payroll_type_of_work?: string;
  payroll_increment_period?: string;
  payroll_increment_type?: string;
  payroll_increment_value?: number;

  payroll_late_allowance_time?: string | Dayjs | null;
  payroll_late_apply_half_day?: boolean | null;
  payroll_late_deduct_commission?: boolean | null;

  payroll_late_commission_percentage?: number | null;

  payroll_early_go_allowance_time?: string | Dayjs | null;
  payroll_early_apply_half_day?: boolean | null;
  payroll_early_deduct_commission?: boolean | null;
  payroll_early_commission_percentage?: number | null;
}
interface PhoneItem {
  first_name?: string;
  last_name?: string;
  label?: string;
  number?: string;
  designation?: string;
  email?: string;
  std_phone?: string;
  type?: string;
  std_code?: string;
  sms?: "Yes" | "No";
  contact_first_name?: string;
  contact_last_name?: string;
  contact_label?: string;
  contact_number?: string;
  contact_designation?: string;
  contact_email?: string;
  contact_type?: string;
  contact_std_phone?: string;
  contact_std_code?: string;
  contact_sms?: "Yes" | "No";
}


interface DocumentItem {
  document_id?: number;
  document_type: string;
  document_name: string;
  attachments: string;
}

interface LedgerFormValues {
  ledger_account_head?: number;
  ledger_sub_account_head?: number;
  ledger_mobile_no?: string;
  ledger_company_name?: string;
  ledger_occupation?: number;
  ledger_designation?: number;
  ledger_opening_balance?: number;
  ledger_opening_type?: string;
  ledger_email?: string;
  ledger_gst_type?: string;
  ledger_gstin?: string;
  ledger_pan_no?: string;
  ledger_cin_no?: string;
  ledger_tin_no?: string;
  ledger_msme_reg_no?: string;
  ledger_import_export_code?: string;
  ledger_bill_to_bill?: 'Yes' | 'No';
  ledger_reserve_fund?: string;
  ledger_tds?: string;
  ledger_deals_in_company?: string[];
  ledger_deals_in_product?: string[];
  ledger_interest_rate?: number;
  ledger_interest_style?: string;
  ledger_credit_limit_day?: number;
  ledger_credit_limit_amount?: number;
  ledger_dob?: dayjs.Dayjs | null;
  ledger_marriage_anniversary?: dayjs.Dayjs | null;
  ledger_work_anniversary?: dayjs.Dayjs | null;
  ledger_status?: number;
  ledger_image?: string;
  links?: LinkItem[];
  banks?: BankItem[];
  addresses?: AddressItem[];
  payrolls?: PayrollItem[];
  phones?: PhoneItem[];
  documents?: DocumentItem[];
  payroll_working_hours?: string;
}




const typeOfWorkOptions = [
  { label: 'Full-time', value: 'full_time' },
  { label: 'Part-time', value: 'part_time' },
  { label: 'Freelance', value: 'freelance' },
  { label: 'Contract', value: 'contract' },
  { label: 'Internship', value: 'internship' },
  { label: 'Temporary', value: 'temporary' },
  { label: 'Remote', value: 'remote' },
  { label: 'On-site', value: 'on_site' },
  { label: 'Hybrid', value: 'hybrid' },
  { label: 'Consulting', value: 'consulting' },
  { label: 'Volunteer', value: 'volunteer' },
  { label: 'Project-based', value: 'project_based' },
  { label: 'Apprenticeship', value: 'apprenticeship' },
  { label: 'Seasonal', value: 'seasonal' },
];

type YesNo = 'Yes' | 'No';


interface LedgerModalProps {
  visible: boolean;
  onCancel: () => void;
  onCreate: (data: any) => void;
  initialValues?: (LedgerFormValues & { ledger_id?: number }) | null;
  isEditMode?: boolean;
}



interface Ledger {
  ledger_id: number;
  ledger_account_head?: number;
  ah_name?: string;
}
interface DesignationItem {
  designation_id: number;
  designation_name: string;
  designation_status: number;
}
interface OccupationItem {
  occupation_id: number;
  occupation_name: string;
  occupation_status: number;
}

const LedgerModal: React.FC<LedgerModalProps> = ({
  visible,
  onCancel,
  onCreate,
  initialValues = null,
  isEditMode = false,
}) => {
  const [form] = Form.useForm<LedgerFormValues>();
  const [accountHeads, setAccountHeads] = useState<AccountHead[]>([]);
  // const [companies, setCompany] = useState<CompanyName[]>([]);
  const [subHeads, setSubHeads] = useState<SubHead[]>([]);


  const [imageFile, setImageFile] = useState<File | null>(null);
  const [profileImageFileList, setProfileImageFileList] = useState<UploadFile[]>([]);


  const [previewOpen, setPreviewOpen] = useState(false);
  const [previewImage, setPreviewImage] = useState('');
  const [previewTitle, setPreviewTitle] = useState('');

  const [selectedOccupation, setSelectedOccupation] = useState<string>("");
  const [selectedDesignation, setSelectedDesignation] = useState<string>("");

  const [showLinks, setShowLinks] = useState(false);



  const [showCompanyDetails, setShowCompanyDetails] = useState(false);

  const [selectedGSTType, setSelectedGSTType] = useState<string>("");

  const [companyCollapsed, setCompanyCollapsed] = useState(false);
  const [gstinChecked, setGstinChecked] = useState(false);

  const [otherCollapsed, setOtherCollapsed] = useState(false);

  const [smsCollapsed, setSmsCollapsed] = useState(false);



  const [product_names, setProductName] = useState<Pn[]>([]);
  const [isProductModalVisible, setIsProductModalVisible] = useState(false);
  const [brandnames, setBrandNames] = useState<BrandNames[]>([]);
  const [cityname, setCityNames] = useState<City[]>([]);
  const [statenames, setStateNames] = useState<State[]>([]);
  const [countrynames, setCountryNames] = useState<Country[]>([]);
  const [isbrandModalVisible, setIsBrandModalVisible] = useState(false);
  const [isCountryModalVisible, setIsCountryModalVisible] = useState(false);
  const [isStateModalVisible, setIsStateModalVisible] = useState(false);
  const [isCityModalVisible, setIsCityModalVisible] = useState(false);


  const [designations, setDesignation] = useState<DesignationItem[]>([]);
  const [isDesignationModalVisible, setIsDesignationModalVisible] = useState(false);
  const [occupations, setOccupations] = useState<OccupationItem[]>([]);
  const [isOccupationModalVisible, setIsOccupationModalVisible] = useState(false);
  type DataType = 'festival' | 'designation' | 'occupation' | 'brand' | 'pname' | 'country' | 'state' | 'city' | 'gsttypes';

  const fetchAllDataSequentially = async (types: DataType[] = ['festival', 'designation', 'occupation', 'brand', 'pname', 'country', 'state', 'city', 'gsttypes']) => {
    try {

      if (types.includes('designation')) {
        const designationData = await apiRequest<DesignationItem[]>({ method: 'get', url: `designation?status=1` });
        setDesignation(designationData);
      }

      if (types.includes('occupation')) {
        const occupationData = await apiRequest<OccupationItem[]>({ method: 'get', url: `occupation?status=1` });
        setOccupations(occupationData);
      }

      if (types.includes('pname')) {
        const pnameData = await apiRequest<Pn[]>({ method: "get", url: `product-names?status=1` });
        setProductName(pnameData)
      }
      if (types.includes('country')) {
        const countryData = await apiRequest<Country[]>({ method: "get", url: `country?status=1` });
        setCountryNames(countryData)
      }
      if (types.includes('state')) {
        const stateData = await apiRequest<State[]>({ method: "get", url: `state?status=1` });
        setStateNames(stateData)
      }
      if (types.includes('city')) {
        const cityData = await apiRequest<City[]>({ method: "get", url: `city?status=1` });
        setCityNames(cityData)
      }
    } catch (error) {
      showError('Failed to fetch some data');
      console.error(error);
    }
  };

  // load in render 
  const debouncedFetchAllData = useMemo(
    () => debounce(fetchAllDataSequentially, 500),
    []
  );

  useEffect(() => {
    debouncedFetchAllData();
    fetchAllDataSequentially(['pname']);
    return () => {
      debouncedFetchAllData.cancel(); // cleanup
    };
  }, []);

  // designations
  const handleDesignationCreated = (data: DesignationItem) => {
    fetchAllDataSequentially(['designation']);
    setIsDesignationModalVisible(false);
  };



  // brand
  const handleBrandCreated = (data: BrandNames) => {
    fetchAllDataSequentially(['brand']);
    setIsBrandModalVisible(false);
  };

  // product names
  const handlePNameCreated = (data: Pn) => {
    fetchAllDataSequentially(['pname']);
    setIsProductModalVisible(false);
  };

  // country names
  const handleCountryCreated = (data: Country) => {
    fetchAllDataSequentially(['country']);
    setIsCountryModalVisible(false);
  };

  // state names
  const handleStateCreated = (data: State) => {
    fetchAllDataSequentially(['state']);
    setIsStateModalVisible(false);
  };

  // city names
  const handleCityCreated = (data: City) => {
    fetchAllDataSequentially(['city']);
    setIsCityModalVisible(false);
  };


  const [showCommissionOption, setShowCommissionOption] = useState(false);
  const [showEarlyGoCommissionOption, setShowEarlyGoCommissionOption] = useState(false);

  // pincode blur handler
  const handlePincodeBlur = async (pincode: string, name: number) => {
    if (!/^\d{6}$/.test(pincode)) return;

    try {
      const data = await apiRequest<{
        city: string;
        state: string;
        country: string;
      }>({
        method: "get",
        url: `lookup/pincode/${pincode}`, // change URL to your actual API endpoint
      });

      const currentAddresses = form.getFieldValue("addresses") || [];
      console.log("Current addresses before update:", currentAddresses);
      const updatedAddresses = [...currentAddresses];


      const cityOption = cityname.find(c => c.city_name === data.city);
      const stateOption = statenames.find(s => s.state_name === data.state);
      const countryOption = countrynames.find(c => c.country_name === data.country);

      updatedAddresses[name] = {
        ...updatedAddresses[name],
        city: cityOption?.city_id,
        state: stateOption?.state_id,
        country: countryOption?.country_id,
      };
      console.log("Updated addresses:", updatedAddresses);

      form.setFieldsValue({ addresses: updatedAddresses });
      console.log("Form values after update:", form.getFieldsValue());
    } catch {
      showError("Could not fetch location data");
    }
  };

  // fetch data for dropdowns
  useEffect(() => {
    apiRequest<AccountHead[]>({ method: "get", url: `account-heads?status=1&ah_parent=0` })
      .then((resp) => setAccountHeads(resp))
      .catch(() => showError("Failed to load account heads"));

    apiRequest<SubHead[]>({ method: "get", url: `account-heads?status=1` })
      .then((resp) => setSubHeads(resp))
      .catch(() => showError("Failed to load sub heads"));




  }, []);




  const formatTimeSafe = (value: any) => {
    if (!value) return "";

    // DayJS object (from TimePicker)
    if (value?.format) {
      return value.format("hh:mm A");
    }

    // ISO strings
    if (typeof value === "string" && value.includes("T")) {
      return dayjs(value).format("hh:mm A");
    }

    // Already AM/PM string -> keep it
    if (/^[0-9]{1,2}:[0-9]{2} (AM|PM)$/i.test(value)) {
      return value;
    }

    return value;
  };



  useEffect(() => {
    const initializeForm = async () => {
      if (!visible) return;

      try {
        console.log("✅ Modal Opened");
        console.log("✅ Edit Mode:", isEditMode);
        console.log("✅ Initial Values:", initialValues);

        // Step 1: Categories fetch करो
        const categoriesData = await apiRequest<Categories[]>({
          method: "get",
          url: "category?status=1",
        });

        console.log("✅ Fetched Categories:", categoriesData);

        if (isEditMode && initialValues) {
          // ==================== EDIT MODE ====================



          // Step 4: Prepare form values for edit mode
          const formValues: LedgerFormValues = {
            ...initialValues,
            ledger_dob: initialValues.ledger_dob ? dayjs(initialValues.ledger_dob) : null,
            ledger_marriage_anniversary: initialValues.ledger_marriage_anniversary
              ? dayjs(initialValues.ledger_marriage_anniversary)
              : null,
            ledger_work_anniversary: initialValues.ledger_work_anniversary
              ? dayjs(initialValues.ledger_work_anniversary)
              : null,

            links: (initialValues.links || []).map(link => ({
              link: link.link_name || "",
              description: link.link_url || "",
            })),

            banks: (initialValues.banks || []).map(bank => ({
              ifsc: bank.bank_account_ifsc || "",
              holder_name: bank.bank_account_holder_name || "",
              bank_name: bank.bank_account_branch_name || "",
              address: bank.bank_account_bank_address || "",
              acc_no: bank.bank_account_account_no || "",
            })),

            phones: (initialValues.phones || []).map(phone => ({
              first_name: phone.contact_first_name || "",
              last_name: phone.contact_last_name || "",
              label: phone.contact_label || "",
              designation: phone.contact_designation || "",
              email: phone.contact_email || "",
              type: phone.contact_type as "mobile" | "phone" | undefined,
              number: phone.contact_number || "",
              std_code: phone.contact_std_code || "",
              std_phone: phone.contact_std_phone || "",
              sms: phone.contact_sms as "Yes" | "No" | undefined,
            })),

            addresses: (initialValues.addresses || []).map(address => ({
              type: address.address_type as "residence" | "office" | undefined,
              landmark: address.address_landmark || "",
              pincode: address.address_pincode || "",
              city: address.address_city || "",
              state: address.address_state || "",
              country: address.address_country || "",
              address: address.address_detail || "",
            })),

            payrolls: (initialValues.payrolls || []).map((p) => ({
              payroll_id: p.payroll_id || undefined,
              payroll_ledger_id: p.payroll_ledger_id || undefined,

              payroll_check_in: p.payroll_check_in
                ? dayjs(p.payroll_check_in, "HH:mm")
                : null,

              payroll_check_out: p.payroll_check_out
                ? dayjs(p.payroll_check_out, "HH:mm")
                : null,

              payroll_working_hours: p.payroll_working_hours || "",

              payroll_lunch_in: p.payroll_lunch_in
                ? dayjs(p.payroll_lunch_in, "HH:mm")
                : null,

              payroll_lunch_out: p.payroll_lunch_out
                ? dayjs(p.payroll_lunch_out, "HH:mm")
                : null,

              payroll_days_of_working: (() => {
                const raw = p.payroll_days_of_working;

                if (Array.isArray(raw)) return raw;          // already array
                if (typeof raw === "string") {
                  return raw
                    .split(",")                               // split by comma
                    .map((d) => d.trim())                     // remove spaces
                    .filter(Boolean);                         // remove empty
                }
                return [];
              })(),

              payroll_days_off: (() => {
                const raw = p.payroll_days_off;

                if (Array.isArray(raw)) return raw;          // already array
                if (typeof raw === "string") {
                  return raw
                    .split(",")                               // split by comma
                    .map((d) => d.trim())                     // remove spaces
                    .filter(Boolean);                         // remove empty
                }
                return [];
              })(),


              payroll_date_of_joining: p.payroll_date_of_joining
                ? dayjs(p.payroll_date_of_joining)
                : null,

              payroll_salary: p.payroll_salary ?? null,

              payroll_type_of_work: p.payroll_type_of_work || "",
              payroll_increment_period: p.payroll_increment_period || "",
              payroll_increment_type: p.payroll_increment_type || "",
              payroll_increment_value: p.payroll_increment_value || undefined,

              payroll_late_allowance_time: p.payroll_late_allowance_time
                ? dayjs(p.payroll_late_allowance_time, "HH:mm")
                : null,

              payroll_late_apply_half_day: (() => {
                const raw = p.payroll_late_apply_half_day as unknown as string;
                return raw === "Yes";
              })(),
              payroll_late_deduct_commission: (() => {
                const raw = p.payroll_late_deduct_commission as unknown as string;
                return raw === "Yes";
              })(),


              payroll_late_commission_percentage: p.payroll_late_commission_percentage ?? null,

              payroll_early_go_allowance_time: p.payroll_early_go_allowance_time
                ? dayjs(p.payroll_early_go_allowance_time, "HH:mm")
                : null,

              payroll_early_apply_half_day: (() => {
                const raw = p.payroll_early_apply_half_day as unknown as string;
                return raw === "Yes";
              })(),

              payroll_early_deduct_commission: (() => {
                const raw = p.payroll_early_deduct_commission as unknown as string;
                return raw === "Yes";
              })(),

              payroll_early_commission_percentage: p.payroll_early_commission_percentage ?? null,
            })),


            ledger_deals_in_product: (() => {
              const raw = initialValues?.ledger_deals_in_product;
              if (Array.isArray(raw)) return raw;
              if (typeof raw === "string") {
                try {
                  const parsed = JSON.parse(raw);
                  console.log("parsed", parsed)
                  console.log("parsed Array.isArray(parsed)", Array.isArray(parsed))
                  return Array.isArray(parsed) ? parsed : [];
                } catch {
                  return [];
                }
              }
              return [];
            })(),

            ledger_deals_in_company: (() => {
              const raw = initialValues.ledger_deals_in_company;
              if (Array.isArray(raw)) return raw;
              if (typeof raw === "string") {
                try {
                  const parsed = JSON.parse(raw);
                  return Array.isArray(parsed) ? parsed : [];
                } catch {
                  return [];
                }
              }
              return [];
            })(),
          };

          // Step 5: Handle ledger image
          if (initialValues.ledger_image) {
            const imageUrl = `${initialValues.ledger_image}`;
            setProfileImageFileList([
              {
                uid: '-1',
                name: 'image.png',
                status: 'done',
                url: imageUrl,
              },
            ]);
            setImageFile(null);
          } else {
            setProfileImageFileList([]);
            setImageFile(null);
          }

          // Step 6: Update categories state

          console.log("✅  form formValues", formValues);
          // Step 7: Set all form values including categories
          form.setFieldsValue({
            ...formValues,
            payrolls: formValues.payrolls,
          });

          console.log("✅ Form Values Set Successfully");

        } else {
          // ==================== ADD MODE ====================

          // Blank categories for new ledger



          // Reset form
          form.resetFields();
          setImageFile(null);
          setProfileImageFileList([]);


          console.log("✅ Add Mode Initialized");
        }

      } catch (error) {
        showError("Failed to initialize form");
        console.error("❌ Error:", error);
      }
    };

    initializeForm();
  }, [visible, isEditMode, initialValues?.ledger_id, form]);


  const onFinish = async (values: LedgerFormValues) => {
    try {
      console.log("Form submit values:", values);
      console.log('ledger_designation:', values.ledger_designation);

      const formData = new FormData();
      if (initialValues?.ledger_id) {
        formData.append("ledger_id", initialValues.ledger_id.toString());
      }
      // Ledger fields
      formData.append("ledger_mobile_no", values.ledger_mobile_no || "");
      formData.append("ledger_company_name", values.ledger_company_name || "");
      formData.append("ledger_occupation", `${values.ledger_occupation || ""}`);
      formData.append("ledger_image", values.ledger_image || "");
      formData.append("ledger_designation", `${values.ledger_designation || null}`);
      formData.append(
        "ledger_opening_balance",
        (values.ledger_opening_balance ?? "").toString()
      );
      formData.append("ledger_opening_type", values.ledger_opening_type || "");
      formData.append("ledger_email", values.ledger_email || "");
      formData.append("ledger_gst_type", values.ledger_gst_type || "");
      formData.append("ledger_gstin", values.ledger_gstin || "");
      formData.append("ledger_pan_no", values.ledger_pan_no || "");
      formData.append("ledger_tin_no", values.ledger_tin_no || "");
      formData.append("ledger_cin_no", values.ledger_cin_no || "");
      formData.append("ledger_msme_reg_no", values.ledger_msme_reg_no || "")
      formData.append("ledger_import_export_code", values.ledger_import_export_code || "")
      formData.append("ledger_bill_to_bill", values.ledger_bill_to_bill || "")
      formData.append(
        "ledger_interest_rate",
        (values.ledger_interest_rate ?? "").toString()
      );
      formData.append("ledger_interest_style", values.ledger_interest_style || "");
      formData.append(
        "ledger_credit_limit_day",
        (values.ledger_credit_limit_day ?? "").toString()
      );
      formData.append(
        "ledger_reserve_fund",
        (values.ledger_reserve_fund ?? "").toString()
      );
      formData.append(
        "ledger_tds",
        (values.ledger_tds ?? "").toString()
      );
      formData.append(
        "ledger_credit_limit_amount",
        (values.ledger_credit_limit_amount ?? "").toString()
      );
      // formData.append("ledger_interest_rate", values.ledger_interest_rate || "");
      // formData.append("ledger_credit_limit_day", values.ledger_credit_limit_day || "");
      // formData.append("ledger_credit_limit_amount", values.ledger_credit_limit_amount || "");
      if (imageFile) {
        formData.append('attachments', imageFile); // ✅ binary file
      }

      formData.append(
        "ledger_deals_in_company",
        Array.isArray(values.ledger_deals_in_company)
          ? JSON.stringify(values.ledger_deals_in_company)
          : "[]"
      );

      formData.append(
        "ledger_deals_in_product",
        Array.isArray(values.ledger_deals_in_product)
          ? JSON.stringify(values.ledger_deals_in_product)
          : "[]"
      );

      // Dates
      if (values.ledger_dob) {
        formData.append("ledger_dob", values.ledger_dob.toISOString());
      }
      if (values.ledger_marriage_anniversary) {
        formData.append(
          "ledger_marriage_anniversary",
          values.ledger_marriage_anniversary.toISOString()
        );
      }
      if (values.ledger_work_anniversary) {
        formData.append(
          "ledger_work_anniversary",
          values.ledger_work_anniversary.toISOString()
        );
      }
      console.log("document data", values);
      // Multiple documents
      values.documents?.forEach((doc, index) => {
        formData.append(
          `documents[${index}][doc_type]`,
          doc.document_type
        );
        formData.append(
          `documents[${index}][doc_name]`,
          doc.document_name
        );



        if (doc.attachments && Array.isArray(doc.attachments)) {
          doc.attachments.forEach((file: any, fIndex: number) => {
            if (file?.originFileObj) {
              // send the actual file
              formData.append(
                `documents[${index}][doc_file][${fIndex}]`,
                file.originFileObj as File
              );
            } else if (file instanceof File) {
              // in case it's already a File
              formData.append(
                `documents[${index}][doc_file][${fIndex}]`,
                file
              );
            }
          });
        }
      });

      // phone
      // values.phones?.forEach((ph, index) => {
      //   const contactType = ph.type ?? "";

      //   formData.append(`phones[${index}][first_name]`, ph.first_name ?? "");
      //   formData.append(`phones[${index}][last_name]`, ph.last_name ?? "");
      //   formData.append(`phones[${index}][label]`, ph.label ?? "");
      //   formData.append(`phones[${index}][designation]`, ph.designation ?? "");
      //   formData.append(`phones[${index}][email]`, ph.email ?? "");
      //   formData.append(`phones[${index}][type]`, contactType);
      //   formData.append(`phones[${index}][sms]`, ph.sms ?? ""); // clear sms


      //   if (contactType === "mobile") {
      //     formData.append(`phones[${index}][number]`, ph.number?.toString() ?? "");
      //     formData.append(`phones[${index}][std_code]`, ""); // clear std_code
      //     formData.append(`phones[${index}][phone_no]`, ""); // clear phone_no
      //     formData.append(`phones[${index}][std_phone]`, ""); // clear std_phone
      //     // formData.append(`phones[${index}][sms]`, ""); // clear sms
      //   } else if (contactType === "phone") {
      //     const stdCode = ph.std_code?.toString() ?? "";
      //     formData.append(`phones[${index}][std_code]`, stdCode);
      //     // formData.append(`phones[${index}][phone_no]`, phoneNo);
      //     // formData.append(`phones[${index}][number]`, ""); // mobile field empty
      //     // formData.append(
      //     //   `phones[${index}][std_phone]`,
      //     //   stdCode && phoneNo ? stdCode + phoneNo : ""
      //     // );
      //     formData.append(`phones[${index}][std_phone]`, ph.std_phone ?? "");

      //   }
      // });
      values.phones?.forEach((ph, index) => {
        formData.append(`phones[${index}][first_name]`, ph.first_name ?? "");
        formData.append(`phones[${index}][last_name]`, ph.last_name ?? "");
        formData.append(`phones[${index}][email]`, ph.email ?? "");
        formData.append(`phones[${index}][designation]`, ph.designation ?? "");
        formData.append(`phones[${index}][sms]`, ph.sms ?? "");
        formData.append(`phones[${index}][number]`, ph.number ?? "");
        formData.append(`phones[${index}][std_code]`, ph.std_code ?? "");
        formData.append(`phones[${index}][std_phone]`, ph.std_phone ?? "");
      });


      // links
      values.links?.forEach((l, index) => {
        formData.append(`links[${index}][link]`, l.link ?? "");
        formData.append(`links[${index}][description]`, l.description ?? "");
      });

      // banks
      values.banks?.forEach((b, index) => {
        formData.append(`banks[${index}][ifsc]`, b.ifsc ?? "");
        formData.append(`banks[${index}][bank_name]`, b.bank_name ?? "");
        formData.append(`banks[${index}][address]`, b.address ?? "");
        formData.append(`banks[${index}][acc_no]`, b.acc_no ?? "");
        formData.append(`banks[${index}][holder_name]`, b.holder_name ?? "");
      });

      // address
      values.addresses?.forEach((a, index) => {
        formData.append(`addresses[${index}][type]`, a.type ?? "");
        formData.append(`addresses[${index}][address]`, a.address ?? "");
        formData.append(`addresses[${index}][landmark]`, a.landmark ?? "");
        formData.append(`addresses[${index}][pincode]`, a.pincode ?? "");
        formData.append(`addresses[${index}][city]`, String(a.city ?? ""));
        formData.append(`addresses[${index}][state]`, String(a.state ?? ""));
        formData.append(`addresses[${index}][country]`, String(a.country ?? ""));
      });

      // PAYROLL
      values.payrolls?.forEach((p, index) => {
        formData.append(`payrolls[${index}][payroll_id]`, String(p.payroll_id ?? ""));
        formData.append(`payrolls[${index}][payroll_ledger_id]`, String(p.payroll_ledger_id ?? ""));

        // ⏰ TIME FIELDS — ALWAYS FORMAT
        formData.append(
          `payrolls[${index}][payroll_check_in]`,
          p.payroll_check_in ? dayjs(p.payroll_check_in).format("hh:mm A") : ""
        );

        formData.append(
          `payrolls[${index}][payroll_check_out]`,
          p.payroll_check_out ? dayjs(p.payroll_check_out).format("hh:mm A") : ""
        );

        formData.append(`payrolls[${index}][payroll_working_hours]`, p.payroll_working_hours ?? "");

        formData.append(
          `payrolls[${index}][payroll_lunch_in]`,
          p.payroll_lunch_in ? dayjs(p.payroll_lunch_in).format("hh:mm A") : ""
        );

        formData.append(
          `payrolls[${index}][payroll_lunch_out]`,
          p.payroll_lunch_out ? dayjs(p.payroll_lunch_out).format("hh:mm A") : ""
        );

        formData.append(
          `payrolls[${index}][payroll_days_of_working]`,
          Array.isArray(p.payroll_days_of_working)
            ? p.payroll_days_of_working.join(", ")
            : ""
        );
        formData.append(
          `payrolls[${index}][payroll_days_off]`,
          Array.isArray(p.payroll_days_off)
            ? p.payroll_days_off.join(", ")
            : ""
        );

        // ⏰ Joining date — convert ISO → yyyy-mm-dd
        formData.append(
          `payrolls[${index}][payroll_date_of_joining]`,
          p.payroll_date_of_joining
            ? dayjs(p.payroll_date_of_joining).format("YYYY-MM-DD")
            : ""
        );

        formData.append(`payrolls[${index}][payroll_salary]`, String(p.payroll_salary ?? ""));

        formData.append(`payrolls[${index}][payroll_type_of_work]`, p.payroll_type_of_work ?? "");
        formData.append(`payrolls[${index}][payroll_increment_period]`, p.payroll_increment_period ?? "");
        formData.append(`payrolls[${index}][payroll_increment_type]`, p.payroll_increment_type ?? "");
        formData.append(`payrolls[${index}][payroll_increment_value]`, String(p.payroll_increment_value ?? ""));


        // ⏰ LATE TIME
        formData.append(`payrolls[${index}][payroll_late_allowance_time]`, formatTimeSafe(p.payroll_late_allowance_time));
        formData.append(
          `payrolls[${index}][payroll_late_apply_half_day]`,
          p.payroll_late_apply_half_day ? "Yes" : "No"
        );
        formData.append(
          `payrolls[${index}][payroll_late_deduct_commission]`,
          p.payroll_late_deduct_commission ? "Yes" : "No"
        );

        formData.append(`payrolls[${index}][payroll_late_commission_percentage]`, String(p.payroll_late_commission_percentage ?? ""));

        // ⏰ EARLY TIME
        formData.append(
          `payrolls[${index}][payroll_early_go_allowance_time]`,
          formatTimeSafe(p.payroll_early_go_allowance_time)
        );

        formData.append(
          `payrolls[${index}][payroll_early_apply_half_day]`,
          p.payroll_early_apply_half_day ? "Yes" : "No"
        );
        formData.append(
          `payrolls[${index}][payroll_early_deduct_commission]`,
          p.payroll_early_deduct_commission ? "Yes" : "No"
        );
        formData.append(`payrolls[${index}][payroll_early_commission_percentage]`, String(p.payroll_early_commission_percentage ?? ""));
      });




      const method = isEditMode ? "put" : "post";
      const url = isEditMode ? "edit-h-ledger" : "add-h-ledger";

      const resp = await apiRequest<any>({
        method,
        url,
        data: formData,
        headers: {
          "Content-Type": "multipart/form-data",
        },
      });

      showSuccess(isEditMode ? "Ledger updated!" : "Ledger created!");
      form.resetFields();
      if (!visible) { //check this
        setImageFile(null);
        setProfileImageFileList([]);
      }
      onCreate(resp);
      onCancel();
    } catch (err) {
      console.error(err);
      showError(isEditMode ? "Update failed" : "Create failed");
    }
  };





  // image preview 
  const handlePreview = async (file: UploadFile) => {
    if (!file.url && !file.preview) {
      file.preview = await getBase64(file.originFileObj as File);
    }

    setPreviewImage(file.url || (file.preview as string));
    setPreviewOpen(true);
    setPreviewTitle(file.name || file.url!.substring(file.url!.lastIndexOf('/') + 1));
  };

  // Utility function to convert image to base64
  const getBase64 = (file: File): Promise<string> =>
    new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = () => resolve(reader.result as string);
      reader.onerror = error => reject(error);
    });

  const uploadButton = (
    <div
      style={{
        width: 220,
        height: 220,
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
      }}
    >
      <PlusOutlined style={{ fontSize: 24 }} />
      <div style={{ marginTop: 8 }}>Upload</div>
    </div>
  );


  const handleOccupationChange = (value: string) => {
    setSelectedOccupation(value);
  };

  const handleDesignationChange = (value: string) => {
    setSelectedDesignation(value);
  };

  const handleGSTTypeChange = (value: string) => {
    setSelectedGSTType(value);
  };

  // Handler for dropdown change
  const onBillToBillChange = (value: string) => {
    setShowLinks(value === "Yes");
    if (value !== "Yes") {
      // Optionally reset links when switching to "No"
      form.setFieldsValue({ links: [] });
    }
  };

  // Outside of return, in the same file
  const autoInsertSlash = (input: HTMLInputElement) => {
    let value = input.value.replace(/\D/g, ""); // Keep only digits

    // Insert slashes automatically after 2nd and 4th digits
    if (value.length > 2) value = value.slice(0, 2) + "/" + value.slice(2);
    if (value.length > 5) value = value.slice(0, 5) + "/" + value.slice(5);

    input.value = value;
  };

  const handleDOBKeyDown = (e: React.KeyboardEvent<HTMLElement>) => {
    const input = e.currentTarget as HTMLInputElement; // Cast to input
    const value = input.value;

    const allowedSpecialKeys = [
      "Backspace",
      "Delete",
      "ArrowLeft",
      "ArrowRight",
      "ArrowUp",
      "ArrowDown",
      "Tab",
      "Escape",
      "Enter",
    ];

    // Allow Ctrl/⌘ + A/C/V/X
    if ((e.ctrlKey || e.metaKey) && ["a", "c", "v", "x"].includes(e.key.toLowerCase())) return;

    // Allow special keys
    if (allowedSpecialKeys.includes(e.key)) return;

    // Count digits in input
    const digitCount = (value.match(/\d/g) || []).length;

    // Allow digits only if less than 8 digits
    if (/^[0-9]$/.test(e.key)) {
      if (digitCount >= 8) {
        e.preventDefault();
        return;
      }
    } else if (e.key === "/" || e.key === "-") {
      // Allow slash or hyphen but max 2
      const count = (value.match(new RegExp(`\\${e.key}`, "g")) || []).length;
      if (count >= 2) {
        e.preventDefault();
        return;
      }
    } else {
      // Block everything else
      e.preventDefault();
      return;
    }

    // Auto-insert slash after 2nd and 4th digits
    setTimeout(() => autoInsertSlash(input), 0); // Timeout to let key input happen
  };

  // for persentage reserve fund, tsd
  // utils/inputValidators.ts
  const decimalInputKeyDown = (
    e: React.KeyboardEvent<HTMLInputElement>,
    maxIntegerDigits = 3,
    maxDecimalDigits = 2,
    maxValue = 100
  ) => {
    const value = e.currentTarget.value;
    const key = e.key;
    const cursorPos = e.currentTarget.selectionStart || 0;

    // Allow copy, cut, paste, select-all
    if ((e.ctrlKey || e.metaKey) && ["c", "x", "v", "a"].includes(key.toLowerCase())) return;

    // Block invalid keys
    if (["-", "+", "e", "E", " "].includes(key)) {
      e.preventDefault();
      return;
    }

    // Allow navigation
    if (["Backspace", "Delete", "ArrowLeft", "ArrowRight", "Tab"].includes(key)) return;

    // Only digits & dot
    if (!/^[0-9.]$/.test(key)) {
      e.preventDefault();
      return;
    }

    // Dot cannot be first
    if (key === "." && value === "") {
      e.preventDefault();
      return;
    }

    // Only one dot
    if (key === "." && value.includes(".")) {
      e.preventDefault();
      return;
    }

    const parts = value.split(".");

    // Before dot: max integer digits
    if (!value.includes(".") && parts[0].length >= maxIntegerDigits && key !== ".") {
      e.preventDefault();
      return;
    }

    // After dot: max decimal digits considering cursor position
    if (value.includes(".") && cursorPos > value.indexOf(".")) {
      const decLength = value.length - value.indexOf(".") - 1;
      if (decLength >= maxDecimalDigits) {
        e.preventDefault();
        return;
      }
    }

    // Max value check
    const newValue = value + key;
    const num = parseFloat(newValue);
    if (!isNaN(num) && num > maxValue) {
      e.preventDefault();
    }
  };


  const decimalInputPaste = (
    e: React.ClipboardEvent<HTMLInputElement>,
    maxIntegerDigits = 3,
    maxDecimalDigits = 2,
    maxValue = 100
  ) => {
    const pasteValue = e.clipboardData.getData("text");

    // Allow only numbers + dot
    if (!/^[0-9.]+$/.test(pasteValue)) {
      e.preventDefault();
      return;
    }

    // Must match pattern: max integer & decimal digits
    const regex = new RegExp(`^\\d{1,${maxIntegerDigits}}(\\.\\d{0,${maxDecimalDigits}})?$`);
    if (!regex.test(pasteValue)) {
      e.preventDefault();
      return;
    }

    // Must not exceed maxValue
    if (parseFloat(pasteValue) > maxValue) {
      e.preventDefault();
      return;
    }
  };


  const handleTimeChange = (changedValues: any, allValues: any) => {
    if (!changedValues.payrolls) return;

    changedValues.payrolls.forEach((changedItem: any, index: number) => {
      const payroll = allValues.payrolls[index];
      if (!payroll) return;

      const { payroll_check_in, payroll_check_out } = payroll;

      if (payroll_check_in && payroll_check_out) {
        const start = dayjs(payroll_check_in);
        const end = dayjs(payroll_check_out);

        let diff = end.diff(start, "minute");
        if (diff < 0) diff += 24 * 60; // overnight shifts

        const hours = Math.floor(diff / 60);
        const minutes = diff % 60;

        const result = minutes > 0 ? `${hours}h ${minutes}m` : `${hours} hours`;

        form.setFields([
          {
            name: ["payrolls", index, "payroll_working_hours"],
            value: result,
          },
        ]);
      }
    });
  };




  return (
    <>
      <Modal
        visible={visible}
        title={isEditMode ? "Edit Ledger" : "Add Ledger"}
        onCancel={onCancel}
        footer={null}
        width="95%"
        destroyOnClose
        maskClosable={false}
        centered
      >

        <Form form={form} layout="vertical" onFinish={onFinish}
          onValuesChange={handleTimeChange}
          initialValues={{
            ledger_status: 1,
          }}>
          <>
            <span><h4 style={{ margin: "0 0 10px 0", padding: 0 }}>Ledger</h4></span>
            <Row gutter={16}>


              {/* Mobile Number */}
              <Col span={8}>
                <Form.Item
                  name="ledger_mobile_no"
                  label="Mobile No"
                  rules={[
                    { required: true, message: "Required" },
                    {
                      pattern: /^[0-9]{10}$/,
                      message: "Mobile number must be 10 digits",
                    },
                  ]}
                >
                  <Form.Item noStyle dependencies={["ledger_mobile_no"]}>
                    {({ getFieldValue, setFieldsValue }) => {
                      const currentValue = getFieldValue("ledger_mobile_no") || "";

                      const handleChange = (
                        e: React.ChangeEvent<HTMLInputElement>
                      ) => {
                        let value = e.target.value;

                        // Allow only digits
                        value = value.replace(/[^0-9]/g, "");

                        // Limit to 10 digits
                        value = value.slice(0, 10);

                        setFieldsValue({ ledger_mobile_no: value });
                      };

                      const handleBlur = () => {
                        const value = getFieldValue("ledger_mobile_no") || "";
                        if (!value) {
                          setFieldsValue({ ledger_mobile_no: "" });
                        }
                      };

                      return (
                        <Input
                          value={currentValue}
                          maxLength={10}
                          type="tel"
                          placeholder="Enter mobile number"
                          onChange={handleChange}
                          onBlur={handleBlur} // <-- Auto-fill here
                          suffix={
                            <span style={{ fontSize: "12px", color: "#888" }}>
                              {currentValue.length}/10
                            </span>
                          }
                        />
                      );
                    }}
                  </Form.Item>
                </Form.Item>
              </Col>
              {/* designation */}
              <Col xs={24} sm={12} md={8}>
                <div style={{ marginBottom: 8, fontWeight: 500 }}>
                  Designation
                </div>

                <Form.Item name="ledger_designation"
                  rules={[{ required: false, message: 'Please select a Designation!' }]}>
                  <AntInput.Group compact style={{ display: 'flex', flexWrap: 'nowrap', width: '100%' }}>
                    <div style={{ flex: 1, minWidth: 0 }}>
                      <Select
                        showSearch
                        placeholder="Select Designation"
                        style={{ width: '100%' }}
                        onChange={(value) => {
                          const selected = designations.find((d) => d.designation_id === value);
                          if (selected) {
                            form.setFieldsValue({ ledger_designation: selected.designation_id });
                          } else {
                            form.setFieldsValue({ ledger_designation: 0 });
                          }
                        }}
                        options={[
                          { label: 'Select Designation', value: null },
                          ...designations.map((d) => ({
                            label: d.designation_name,
                            value: d.designation_id,
                          })),
                        ]}
                        allowClear
                        filterOption={(input, option) =>
                          (option?.label as string).toLowerCase().includes(input.toLowerCase())
                        }
                        dropdownMatchSelectWidth={false}
                        value={form.getFieldValue('ledger_designation')}
                      />
                    </div>
                    <Button
                      style={{ padding: 0, flexShrink: 0 }}
                      type="primary"
                      icon={<PlusOutlined />}
                      onClick={() => setIsDesignationModalVisible(true)}
                    />
                  </AntInput.Group>
                </Form.Item>



                <DesignationModel
                  visible={isDesignationModalVisible}
                  onCancel={() => setIsDesignationModalVisible(false)}
                  onCreate={handleDesignationCreated}
                  isEditMode={false}
                  initialValues={null}
                />
              </Col>


              {/* Email */}
              <Col span={8}>
                <Form.Item
                  name="ledger_email"
                  label="Email"
                  rules={[
                    { type: 'email', message: 'Please enter a valid email address' },
                  ]}
                >
                  <Input
                    placeholder="example@email.com"
                    maxLength={100}
                    onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
                      let value = e.target.value;

                      // Allow only email-related characters: letters, numbers, @, ., -, _
                      value = value.replace(/[^a-zA-Z0-9@._-]/g, "");

                      // Convert to lowercase and limit to 100 chars
                      value = value.toLowerCase().slice(0, 100);

                      // Only update this field
                      form.setFieldsValue({ ledger_email: value });
                    }}
                    onPaste={(e) => {
                      // Prevent pasting invalid characters
                      const paste = e.clipboardData.getData('text');
                      if (/[^a-zA-Z0-9@._-]/.test(paste)) {
                        e.preventDefault();
                      }
                    }}
                    onCopy={(e) => {
                      // Optional: allow copy but could clean text if needed
                    }}
                    suffix={
                      <span style={{ fontSize: "12px", color: "#888" }}>
                        {(form.getFieldValue("ledger_email") || "").length}/100
                      </span>
                    }
                  />
                </Form.Item>
              </Col>



              {/* ledger_status */}
              <Col span={8}>
                <Form.Item name="ledger_status" label="Status">
                  <Select allowClear placeholder="Select status">
                    <Option value={1}>Active</Option>
                    <Option value={0}>Inactive</Option>
                  </Select>
                </Form.Item>
              </Col>


              {/* <Divider style={{ marginTop: 4, marginBottom: 16 }} /> */}

              <Form.Item shouldUpdate noStyle>
                {(form) => (
                  <div style={{
                    background: "#f5f5f5",
                    width: "98%",
                    margin: "0 auto 20px auto",
                    padding: "24px 8px",
                    borderRadius: "6px",
                    // margin: '0 0 20px 0',
                    alignItems: "center",
                    justifyContent: "space-between",
                  }}>
                    <Row
                      gutter={16}
                      style={{
                        margin: 0,
                        alignItems: "center",
                      }}
                    >
                      <Col span={12}>
                        <span><h4 style={{ margin: "10px 0 10px 0", padding: 0 }}>Company Info </h4></span>
                      </Col>

                      <Col span={12} style={{ textAlign: "right" }}>
                        <Button
                          type="text"
                          size="small"
                          icon={companyCollapsed ? <CaretUpOutlined /> : <CaretDownOutlined />}
                          onClick={() => setCompanyCollapsed(!companyCollapsed)}
                        >
                          {companyCollapsed ? "Hide" : "Add"}
                        </Button>
                      </Col>
                    </Row>
                    {/* Company Details block */}
                    {companyCollapsed && (
                      <div
                        style={{
                          background: "#f5f5f5",
                          borderRadius: "6px",
                          marginTop: 16,
                          position: "relative",
                        }}
                      >
                        <Row gutter={16}>
                          {/* Company Name */}
                          <Col span={8}>
                            <Form.Item
                              name="ledger_company_name"
                              label="Company Name"
                              rules={[
                                { required: false, message: "Company Name is required" },
                                {
                                  pattern: /^[A-Za-z0-9&.,'()\- ]+$/,
                                  message: "Company Name contains invalid characters",
                                },
                                {
                                  pattern: /^(?!\d+$).+$/,
                                  message: "Company Name cannot be only numbers",
                                },
                              ]}
                            >
                              <Form.Item noStyle dependencies={["ledger_company_name"]}>
                                {({ getFieldValue, setFieldsValue }) => {
                                  const currentValue = getFieldValue("ledger_company_name") || "";

                                  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
                                    let value = e.target.value;

                                    // ❌ DO NOT remove numbers
                                    // ❌ DO NOT remove special company characters
                                    // Only remove completely invalid characters (emoji etc.)
                                    value = value.replace(/[^A-Za-z0-9&.,'()\- ]/g, "");

                                    // Max 100 chars
                                    value = value.slice(0, 100);

                                    // First letter uppercase
                                    if (value.length > 0) {
                                      value = value.charAt(0).toUpperCase() + value.slice(1);
                                    }

                                    setFieldsValue({ ledger_company_name: value });
                                  };

                                  return (
                                    <Input
                                      value={currentValue}
                                      maxLength={100}
                                      onChange={handleChange}
                                      placeholder="Enter company name"
                                      style={{ background: "#f5f5f5" }}
                                      suffix={
                                        <span style={{ fontSize: "12px", color: "#888", }}>
                                          {currentValue.length}/100
                                        </span>
                                      }
                                    />
                                  );
                                }}
                              </Form.Item>
                            </Form.Item>
                          </Col>

                          {/* GSTIN/UIN */}
                          <Col span={8}>
                            <Form.Item
                              name="ledger_gstin"
                              label="GSTIN/UIN"
                              rules={[
                                {
                                  pattern: /^[0-9]{2}[A-Z]{5}[0-9]{4}[A-Z]{1}[1-9A-Z]{1}Z[0-9A-Z]{1}$/,
                                  message: "Enter valid 15-character GSTIN",
                                },
                              ]}
                              getValueFromEvent={(e) => {
                                let value = e.target.value;
                                value = value.replace(/[^0-9a-zA-Z]/g, "").toUpperCase();
                                if (value.length > 15) value = value.slice(0, 15);
                                return value;
                              }}
                            >
                              <Input
                                placeholder="Enter GSTIN"
                                maxLength={15}
                                style={{ background: "#f5f5f5" }}
                                onChange={async (e) => {
                                  const gstin = e.target.value.toUpperCase();
                                  const length = gstin.length;

                                  // update counter safely
                                  const counterEl = document.getElementById("gstin-counter");
                                  if (counterEl) counterEl.innerText = `${length}/15`;

                                  // reset flag if user edits again
                                  if (length < 15) {
                                    setGstinChecked(false);
                                    return;
                                  }

                                  // only run when EXACTLY 15 chars & not already called
                                  if (length === 15 && !gstinChecked) {
                                    setGstinChecked(true);

                                    // ✅ Extract PAN (3–12)
                                    const panFromGstin = gstin.slice(2, 12);
                                    form.setFieldsValue({ ledger_pan_no: panFromGstin });

                                    try {
                                      const response = await apiRequest({
                                        url: "check-gstin",
                                        method: "get",
                                        params: { gstIn: gstin },
                                      });

                                      if (response?.result) {
                                        form.setFieldsValue({
                                          ledger_company_name: response?.result?.legal_name?.value || "",
                                        });
                                      } else {
                                        showSuccess(response?.message || "GSTIN found");
                                      }
                                    } catch (err) {
                                      showError("Failed to validate GSTIN");
                                      console.error(err);
                                    }
                                  }
                                }}
                                suffix={
                                  <span id="gstin-counter" style={{ fontSize: "12px", color: "#888" }}>
                                    0/15
                                  </span>
                                }
                                onBlur={async (e) => {
                                  const gstin = e.target.value.trim();
                                  if (!gstin) return;

                                  // ✅ Extract PAN from GSTIN (characters 3-12)
                                  if (gstin.length === 15) {
                                    const panFromGstin = gstin.slice(2, 12);
                                    form.setFieldsValue({ ledger_pan_no: panFromGstin });
                                  }

                                  // ✅ GSTIN API validation
                                  try {
                                    const response = await apiRequest({
                                      url: "check-gstin",
                                      method: "get",
                                      params: { gstIn: gstin },
                                    });

                                    console.log("GSTIN valid:", response);
                                    if (response?.result) {
                                      // GSTIN is valid, optionally show success
                                      form.setFieldsValue({ ledger_company_name: response?.result?.legal_name?.value || "" });
                                    } else {
                                      showSuccess(response?.message || "Found GSTIN");
                                    }
                                  } catch (err) {
                                    showError("Failed to validate GSTIN");
                                    console.error(err);
                                  }
                                }}
                              />
                            </Form.Item>
                          </Col>

                          {/* Pan no.  */}
                          <Col span={8}>
                            <Form.Item
                              name="ledger_pan_no"
                              label="PAN No"
                              rules={[
                                {
                                  pattern: /^[A-Z0-9]{10}$/,
                                  message: "Enter valid 10-character PAN No",
                                },
                              ]}
                              getValueFromEvent={(e) => {
                                let value = e.target.value;

                                // Sirf numbers aur alphabets allow karo
                                value = value.replace(/[^0-9a-zA-Z]/g, "");

                                // Auto-uppercase me convert karo
                                value = value.toUpperCase();

                                // Max 10 characters limit
                                if (value.length > 10) {
                                  value = value.slice(0, 10);
                                }

                                return value;
                              }}
                            >
                              <Input
                                placeholder="Enter PAN No"
                                maxLength={10}
                                style={{ background: "#f5f5f5" }}
                                onChange={(e) => {
                                  // Live counter update
                                  const counterEl = document.getElementById("pan-counter");
                                  if (counterEl) {
                                    counterEl.innerText = `${e.target.value.length}/10`;
                                  }
                                }}
                                suffix={
                                  <span
                                    id="pan-counter"
                                    style={{ fontSize: "12px", color: "#888" }}
                                  >
                                    0/10
                                  </span>
                                }
                              />
                            </Form.Item>
                          </Col>

                          {/* Tin No */}
                          <Col span={8}>
                            <Form.Item
                              name="ledger_tin_no"
                              label="TIN No"
                              style={{ background: "#f5f5f5" }}
                              rules={[
                                {
                                  pattern: /^[0-9]{11}$/,
                                  message: "TIN must be exactly 11 digits",
                                },
                              ]}
                            >
                              <Input
                                maxLength={11}
                                placeholder="Enter TIN No"
                                style={{ background: "#f5f5f5" }}
                                onChange={(e) => {
                                  const digitsOnly = e.target.value.replace(/\D/g, "");
                                  form.setFieldsValue({ ledger_tin_no: digitsOnly });

                                  const counterEl = document.getElementById("tin-counter");
                                  if (counterEl) {
                                    counterEl.innerText = `${digitsOnly.length}/11`;
                                    counterEl.style.color = digitsOnly.length === 11 ? "red" : "#888";
                                  }
                                }}
                                suffix={
                                  <span id="tin-counter" style={{ fontSize: "12px", color: "#888" }}>
                                    0/11
                                  </span>
                                }
                              />
                            </Form.Item>
                          </Col>

                          {/* Cin No */}
                          <Col span={8}>
                            <Form.Item
                              name="ledger_cin_no"
                              label="CIN No"
                              style={{ background: "#f5f5f5" }}
                              rules={[
                                {
                                  pattern: /^[LU][0-9]{5}[A-Z]{2}[0-9]{4}[A-Z]{3}[0-9]{6}$/,
                                  message: "Valid CIN format required (e.g., U12345MH2006PTC123456)",
                                },
                              ]}
                            >
                              <Input
                                maxLength={21}
                                placeholder="e.g., U12345MH2006PTC123456"
                                style={{ background: "#f5f5f5" }}
                                onChange={(e) => {
                                  const upperCaseValue = e.target.value.toUpperCase();
                                  form.setFieldsValue({ ledger_cin_no: upperCaseValue });

                                  const counterEl = document.getElementById("cin-counter");
                                  if (counterEl) {
                                    counterEl.innerText = `${upperCaseValue.length}/21`;
                                    counterEl.style.color =
                                      upperCaseValue.length === 21 ? "red" : "#888";
                                  }
                                }}
                                suffix={
                                  <span
                                    id="cin-counter"
                                    style={{ fontSize: "12px", color: "#888" }}
                                  >
                                    0/21
                                  </span>
                                }
                              />
                            </Form.Item>
                          </Col>


                          {/* MSME Teg no */}
                          <Col span={8}>
                            <Form.Item
                              name="ledger_msme_reg_no"
                              label="MSME Registration Number"
                              style={{ background: "#f5f5f5" }}
                              rules={[
                                { required: false, message: "Please enter your MSME Registration Number" },
                                {
                                  pattern: MSME_REGEX,
                                  message: "Enter a valid MSME Reg No (e.g. UDYAM-GJ-12-1234567)",
                                },
                              ]}
                            >
                              <Input
                                maxLength={25}
                                placeholder="e.g. UDYAM-GJ-12-1234567"
                                style={{ background: "#f5f5f5" }}
                                onChange={(e) => {
                                  const value = e.target.value.toUpperCase(); // Force uppercase
                                  form.setFieldsValue({ ledger_msme_reg_no: value });

                                  const counterEl = document.getElementById("msme-counter");
                                  if (counterEl) {
                                    counterEl.innerText = `${value.length}/25`;
                                    counterEl.style.color = value.length === 25 ? "red" : "#888";
                                  }
                                }}
                                suffix={
                                  <span
                                    id="msme-counter"
                                    style={{ fontSize: "12px", color: "#888" }}
                                  >
                                    0/25
                                  </span>
                                }
                              />
                            </Form.Item>
                          </Col>

                          {/* Importer-Exporter Code */}
                          <Col span={8}>
                            <Form.Item
                              name="ledger_import_export_code"
                              label="Importer-Exporter Code"
                              style={{ background: "#f5f5f5" }}
                              rules={[
                                { required: false, message: "Please enter your Importer-Exporter Code" },
                              ]}
                            >
                              <Input
                                maxLength={10}
                                placeholder="e.g. "
                                style={{ background: "#f5f5f5" }}
                                onChange={(e) => {
                                  const value = e.target.value.toUpperCase(); // Force uppercase
                                  form.setFieldsValue({ ledger_import_export_code: value });

                                }}
                              />
                            </Form.Item>
                          </Col>

                          {/* Deals in products */}
                          <Col xs={24} sm={12} md={8}>
                            <div style={{ marginBottom: 8, fontWeight: 500 }}>
                              Products
                            </div>

                            <Form.Item name="ledger_deals_in_product"
                              rules={[{ required: false, message: 'Please select a product!' }]}>
                              <AntInput.Group compact style={{ display: 'flex', flexWrap: 'nowrap', width: '100%' }}>
                                <div style={{ flex: 1, minWidth: 0 }}>
                                  <Select
                                    allowClear
                                    mode="multiple"
                                    showSearch
                                    className="custom-select"
                                    optionFilterProp="children"
                                    placeholder="Select product"
                                    style={{ width: '100%', border: '1px solid #d9d9d9', borderRadius: '4px' }}
                                    onChange={(value) => form.setFieldsValue({ ledger_deals_in_product: value })}
                                    options={[
                                      { label: 'Select product', value: null },
                                      ...product_names.map((pn) => ({
                                        label: pn.pn_name,
                                        value: pn.pn_id,
                                      })),
                                    ]}
                                    filterOption={(input, option) =>
                                      (option?.label as string).toLowerCase().includes(input.toLowerCase())
                                    }
                                    dropdownMatchSelectWidth={false}
                                    value={form.getFieldValue('ledger_deals_in_product')}
                                  />
                                </div>
                                <Button
                                  style={{ padding: 0, flexShrink: 0 }}
                                  type="primary"
                                  icon={<PlusOutlined />}
                                  onClick={() => setIsProductModalVisible(true)}
                                />
                              </AntInput.Group>
                            </Form.Item>
                          </Col>
                        </Row>
                      </div>
                    )}
                  </div>
                )}
              </Form.Item>






            </Row>


            {/* Address */}
            <Form.List name="addresses">
              {(fields, { add, remove }) => (
                <div
                  style={{
                    background: "#f5f5f5",
                    padding: "16px",
                    borderRadius: "8px",
                    marginBottom: "24px",
                  }}
                >
                  {/* Header and Add Button aligned */}
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "space-between",
                      alignItems: "baseline",
                      marginBottom: 12,
                    }}
                  >
                    <h4 style={{ marginBottom: 0 }}>Fixed Addresses</h4>
                    <Button
                      type="dashed"
                      onClick={() => add()}
                      icon={<PlusOutlined />}
                      size="middle"
                    >
                      Add address
                    </Button>
                  </div>

                  {fields.map(({ key, name, ...rest }) => (
                    <div
                      key={key}
                      style={{
                        marginBottom: 16,
                        padding: 16,
                        borderRadius: 6,
                        background: "#f5f5f5",
                      }}
                    >
                      <Row gutter={8}>
                        {/* Address Type  */}
                        <Col span={6}>
                          <Form.Item
                            {...rest}
                            name={[name, "type"]}
                            label="Type"
                            style={{ marginBottom: 8, backgroundColor: "#f5f5f5" }}
                          >
                            <Select
                              style={{ backgroundColor: "#f5f5f5" }}
                              placeholder="Select type"
                              dropdownStyle={{ backgroundColor: "#f5f5f5" }}
                              popupClassName="custom-select-dropdown"
                              className="custom-select"
                            >
                              <Option value="residence">Residence</Option>
                              <Option value="office">Office</Option>
                              <Option value="postal">Postal</Option>
                            </Select>
                          </Form.Item>
                        </Col>

                        {/* Address */}
                        <Col span={18}>
                          <Form.Item
                            {...rest}
                            name={[name, "address"]}
                            label="Address"
                            style={{ marginBottom: 8 }}
                          >
                            <Input placeholder="Full address" />
                          </Form.Item>
                        </Col>
                      </Row>

                      <Row gutter={8}>
                        {/* Landmark */}
                        <Col span={6}>
                          <Form.Item
                            {...rest}
                            name={[name, "landmark"]}
                            label="Landmark"
                            style={{ marginBottom: 8 }}
                          >
                            <Input placeholder="Enter landmark" />
                          </Form.Item>
                        </Col>

                        {/* Pincode */}
                        <Col span={6}>
                          <Form.Item
                            {...rest}
                            name={[name, "pincode"]}
                            label="Pincode"
                            style={{ marginBottom: 8 }}
                          >
                            <Form.Item noStyle dependencies={[[name, "pincode"]]}>
                              {({ getFieldValue, setFieldsValue }) => {
                                const currentValue = getFieldValue([name, "pincode"]) || "";

                                const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
                                  let value = e.target.value;

                                  // Allow only digits
                                  value = value.replace(/[^0-9]/g, "");

                                  // Limit to 6 digits
                                  value = value.slice(0, 6);

                                  // Update form
                                  setFieldsValue({ [name]: { ...getFieldValue(name), pincode: value } });
                                };

                                return (
                                  <Input
                                    value={currentValue}
                                    maxLength={6}
                                    type="tel"
                                    style={{ background: '#f5f5f5' }}
                                    placeholder="Enter pincode"
                                    onChange={handleChange}
                                    onBlur={(e) => handlePincodeBlur(e.target.value, name)}
                                    suffix={
                                      <span style={{ fontSize: "12px", color: "#888" }}>
                                        {currentValue.length}/6
                                      </span>
                                    }
                                  />
                                );
                              }}
                            </Form.Item>
                          </Form.Item>
                        </Col>

                        {/* City */}
                        <Col span={6}>
                          <Form.Item
                            {...rest}
                            name={[name, "city"]}
                            label="City"
                            rules={[{ required: true, message: "Select city" }]}
                          >
                            <div style={{ display: "flex", width: "100%" }}>
                              {/* Select input */}
                              <Form.Item noStyle name={[name, "city"]}>
                                <Select
                                  showSearch
                                  placeholder="Select City"
                                  style={{
                                    flex: 1,
                                    borderTopRightRadius: 0,
                                    borderBottomRightRadius: 0,
                                  }}
                                  filterOption={(input, option) =>
                                    (option?.label ?? "").toLowerCase().includes(input.toLowerCase())
                                  }
                                  options={cityname.map((city: City) => ({
                                    label: city.city_name,
                                    value: city.city_id,
                                  }))}
                                />
                              </Form.Item>

                              {/* + Button flush with input */}
                              <Button
                                type="primary"
                                icon={<PlusOutlined />}
                                style={{
                                  padding: 0,
                                  marginLeft: 0,
                                  borderTopLeftRadius: 0,
                                  borderBottomLeftRadius: 0,
                                }}
                                onClick={() => setIsCityModalVisible(true)}
                              />
                            </div>
                          </Form.Item>

                          <CityModal
                            visible={isCityModalVisible}
                            onCancel={() => setIsCityModalVisible(false)}
                            onCreate={handleCityCreated}
                          />
                        </Col>


                        {/* State */}
                        <Col span={6}>
                          <Form.Item
                            {...rest}
                            name={[name, "state"]}
                            label="State"
                            rules={[{ required: true, message: "Select state" }]}
                          >
                            <div style={{ display: "flex", width: "100%" }}>
                              <Form.Item noStyle name={[name, "state"]}>
                                <Select
                                  showSearch
                                  placeholder="Select State"
                                  style={{
                                    flex: 1,
                                    borderTopRightRadius: 0,
                                    borderBottomRightRadius: 0,
                                  }}
                                  filterOption={(input, option) =>
                                    (option?.label ?? "").toLowerCase().includes(input.toLowerCase())
                                  }
                                  options={statenames.map((s) => ({
                                    label: s.state_name,
                                    value: s.state_id,
                                  }))}
                                />
                              </Form.Item>

                              <Button
                                type="primary"
                                icon={<PlusOutlined />}
                                style={{
                                  padding: 0,
                                  marginLeft: 0,
                                  borderTopLeftRadius: 0,
                                  borderBottomLeftRadius: 0,
                                }}
                                onClick={() => setIsStateModalVisible(true)}
                              />
                            </div>
                          </Form.Item>

                          <StateModal
                            visible={isStateModalVisible}
                            onCancel={() => setIsStateModalVisible(false)}
                            onCreate={handleStateCreated}
                          />
                        </Col>




                      </Row>

                      <Row gutter={8} align="middle">
                        {/* Country */}
                        <Col span={6}>
                          <Form.Item
                            {...rest}
                            name={[name, "country"]}
                            label="Country"
                            rules={[{ required: true, message: "Select country" }]}
                          >
                            <div style={{ display: "flex", width: "100%" }}>
                              <Form.Item noStyle name={[name, "country"]}>
                                <Select
                                  showSearch
                                  placeholder="Select Country"
                                  style={{
                                    flex: 1,
                                    borderTopRightRadius: 0,
                                    borderBottomRightRadius: 0,
                                  }}
                                  filterOption={(input, option) =>
                                    (option?.label ?? "").toLowerCase().includes(input.toLowerCase())
                                  }
                                  options={countrynames.map((c) => ({
                                    label: c.country_name,
                                    value: c.country_id,
                                  }))}
                                />
                              </Form.Item>

                              <Button
                                type="primary"
                                icon={<PlusOutlined />}
                                style={{
                                  padding: 0,
                                  marginLeft: 0,
                                  borderTopLeftRadius: 0,
                                  borderBottomLeftRadius: 0,
                                }}
                                onClick={() => setIsCountryModalVisible(true)}
                              />
                            </div>
                          </Form.Item>

                          <CountryModal
                            visible={isCountryModalVisible}
                            onCancel={() => setIsCountryModalVisible(false)}
                            onCreate={handleCountryCreated}
                          />
                        </Col>
                        <Col span={12} style={{ textAlign: "right" }}>
                          <Button
                            danger
                            icon={<MinusCircleOutlined />}
                            onClick={() => remove(name)}
                          >
                            Remove address
                          </Button>
                        </Col>
                      </Row>
                    </div>
                  ))}
                </div>
              )}
            </Form.List>

            {/* Phones */}
            <Form.List name="phones">
              {(fields, { add, remove }) => (
                <div
                  style={{
                    background: "#f5f5f5",
                    padding: "16px",
                    borderRadius: "6px",
                    marginBottom: "24px",
                  }}
                >
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "space-between",
                      alignItems: "baseline",
                      marginBottom: 12,
                    }}
                  >
                    <h4 style={{ marginBottom: 0 }}>Phone Numbers</h4>
                    <Button
                      type="dashed"
                      onClick={() => add()}
                      icon={<PlusOutlined />}
                      size="middle"
                    >
                      Add contact
                    </Button>
                  </div>

                  {fields.map(({ key, name, ...rest }) => (
                    <>
                      <Row key={key} gutter={16} align="middle" style={{ marginBottom: 8 }}>

                        {/* First Name */}
                        <Col span={8}>
                          <Form.Item
                            {...rest}
                            name={[name, "first_name"]}
                            label="First Name"
                            rules={[{ required: true, message: "First name required" }]}
                            normalize={(value) =>
                              value
                                ?.replace(/[^a-zA-Z ]/g, "")
                                .slice(0, 50)
                            }
                          >
                            <Input placeholder="First name" />
                          </Form.Item>
                        </Col>

                        {/* Last Name */}
                        <Col span={8}>
                          <Form.Item
                            {...rest}
                            name={[name, "last_name"]}
                            label="Last Name"
                            rules={[{ required: true, message: "Last name required" }]}
                            normalize={(value) =>
                              value
                                ?.replace(/[^a-zA-Z ]/g, "")
                                .slice(0, 50)
                            }
                          >
                            <Input placeholder="Last name" />
                          </Form.Item>
                        </Col>


                        {/* Phone Designation */}
                        {/* <Col span={8}>
                          <Form.Item {...rest}
                            label="Designation"
                            name={[name, "designation"]}>
                            <Select
                              showSearch
                              placeholder="Select your designation"
                              value={selectedDesignation}
                              onChange={handleDesignationChange}
                              options={designationOptions}
                              filterOption={(input, option) =>
                                (option?.label as string).toLowerCase().includes(input.toLowerCase())
                              }
                              style={{ width: '100%' }}
                            />
                          </Form.Item>
                        </Col> */}

                        {/* Designation inside Form.List */}
                        <Col span={8}>
                          <Form.Item
                            {...rest}
                            label="Designation"
                            name={[name, "designation"]}
                            rules={[{ required: false, message: "Please select a Designation!" }]}
                          >
                            <AntInput.Group
                              compact
                              style={{ display: "flex", flexWrap: "nowrap", width: "100%", background: "#f5f5f5" }}
                            >
                              <div style={{ flex: 1, minWidth: 0 }}>
                                <Select
                                  showSearch
                                  className="custom-select"
                                  placeholder="Select Designation"
                                  value={form.getFieldValue(["phones", name, "designation"])}
                                  onChange={(value) => {
                                    const phones = form.getFieldValue("phones") || [];
                                    phones[name] = { ...phones[name], designation: value };
                                    form.setFieldsValue({ phones });
                                  }}
                                  options={designations.map((desig) => ({
                                    label: desig.designation_name,
                                    value: desig.designation_id,
                                  }))}
                                  allowClear
                                  filterOption={(input, option) =>
                                    (option?.label as string).toLowerCase().includes(input.toLowerCase())
                                  }
                                  dropdownMatchSelectWidth={false}
                                  style={{ width: "100%", background: "#f5f5f5" }}
                                />
                              </div>
                              <Button
                                style={{ padding: 0, flexShrink: 0 }}
                                type="primary"
                                icon={<PlusOutlined />}
                                onClick={() => setIsDesignationModalVisible(true)}
                              />
                            </AntInput.Group>
                          </Form.Item>
                        </Col>



                        {/* Mobile Number */}
                        <Col span={8}>
                          <Form.Item
                            {...rest}
                            name={[name, "number"]}
                            label="Mobile Number"
                            rules={[
                              { required: true, message: "Mobile number required" },
                              { pattern: /^[0-9]{10}$/, message: "Must be 10 digits" },
                            ]}
                          >
                            <Input
                              placeholder="Mobile Number"
                              maxLength={10}
                              onChange={(e) => {
                                const value = e.target.value; // ✅ No cleaning
                                const phones = form.getFieldValue("phones") || [];
                                phones[name] = {
                                  ...phones[name], // Keep all existing fields
                                  number: value,   // Only update this field
                                };
                                form.setFieldsValue({ phones });
                              }}
                            />
                          </Form.Item>
                        </Col>


                        {/* Email */}
                        <Col span={8}>
                          <Form.Item
                            {...rest}
                            name={[name, "email"]}
                            label="Email"
                            rules={[{ type: "email", message: "Please enter a valid email address" }]}
                          >
                            <Input
                              placeholder="example@email.com"
                              maxLength={100}
                              style={{ background: "#f5f5f5" }}
                              showCount
                              onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
                                let value = e.target.value;

                                // Allow only email-related characters: letters, numbers, @, ., -, _
                                value = value.replace(/[^a-zA-Z0-9@._-]/g, "");

                                // Convert to lowercase and limit to 100 chars
                                value = value.toLowerCase().slice(0, 100);

                                // Only update this nested field
                                const phones = form.getFieldValue("phones") || [];
                                phones[name] = {
                                  ...phones[name],
                                  email: value,
                                };
                                form.setFieldsValue({ phones });
                              }}
                              onPaste={(e) => {
                                // Prevent pasting invalid characters
                                const paste = e.clipboardData.getData("text");
                                if (/[^a-zA-Z0-9@._-]/.test(paste)) {
                                  e.preventDefault();
                                }
                              }}
                            />
                          </Form.Item>
                        </Col>



                        {/* Label */}
                        {/* <Col span={8}>
                          <Form.Item {...rest} name={[name, "label"]}
                            label="Label"
                          >
                            <Input placeholder="Label" />
                          </Form.Item>
                        </Col> */}

                        {/* Contact Type */}
                        {/* <Col span={8}>
                          <Form.Item
                            {...rest}
                            name={[name, "type"]}
                            label="Contact Type"
                            rules={[{ required: true, message: "Select type" }]}
                          >
                            <Select placeholder="Select Contact Type">
                              <Select.Option value="mobile">Mobile</Select.Option>
                              <Select.Option value="phone">Phone</Select.Option>
                            </Select>
                          </Form.Item>
                        </Col> */}

                        {/* STD Code */}
                        <Col span={8}>
                          <Form.Item
                            {...rest}
                            name={[name, "std_code"]}
                            label="STD Code"
                            rules={[
                              { required: true, message: "STD code required" },
                              { pattern: /^[0-9]{1,5}$/, message: "Max 5 digits" },
                            ]}
                          >
                            <Input
                              placeholder="STD"
                              maxLength={5}
                              style={{ background: "#f5f5f5" }}
                              onChange={(e) => {
                                let value = e.target.value;
                                // ✅ Allow only digits
                                value = value.replace(/\D/g, "");
                                const phones = form.getFieldValue("phones") || [];
                                phones[name] = {
                                  ...phones[name], // Keep all existing fields
                                  std_code: value, // Only update this field
                                };
                                form.setFieldsValue({ phones });
                              }}
                            />
                          </Form.Item>
                        </Col>

                        {/* Phone Number */}
                        <Col span={8}>
                          <Form.Item
                            {...rest}
                            name={[name, "std_phone"]}
                            label="Telephone Number"
                            rules={[
                              { required: true, message: "STD phone required" },
                              { pattern: /^[0-9]{6,10}$/, message: "6–10 digits" },
                            ]}
                          >
                            <Input
                              placeholder="Enter Telephone Number"
                              maxLength={10}
                              onChange={(e) => {
                                let value = e.target.value;
                                value = value.replace(/\D/g, "");
                                const phones = form.getFieldValue("phones") || [];
                                phones[name] = {
                                  ...phones[name],   // Keep all existing fields
                                  std_phone: value,  // Only update this field
                                };
                                form.setFieldsValue({ phones });
                              }}
                            />
                          </Form.Item>
                        </Col>

                        {/* SMS */}
                        <Col span={8}>
                          <Form.Item
                            {...rest}
                            name={[name, "sms"]}
                            label="SMS"
                            rules={[{ required: true, message: "Select SMS" }]}
                          >
                            <Select placeholder="Select  SMS" className="custom-select" style={{ background: "#f5f5f5" }}>
                              <Select.Option value="Yes">Yes</Select.Option>
                              <Select.Option value="No">No</Select.Option>
                            </Select>
                          </Form.Item>
                        </Col>
                      </Row>

                      <Row justify="end">
                        {/* Remove button */}
                        <Col span={3} style={{ display: 'flex', alignItems: 'center' }}>
                          <Tooltip title="Remove contact">
                            <Button
                              danger
                              icon={<MinusCircleOutlined />}
                              onClick={() => remove(name)}
                            >
                              Remove contact
                            </Button>
                          </Tooltip>
                        </Col>
                      </Row>
                    </>
                  ))}
                </div>
              )}
            </Form.List>


            {/* Banks section */}
            <Form.List name="banks">
              {(fields, { add, remove }) => (
                <div
                  style={{
                    background: "#f5f5f5", // background color for entire block
                    padding: "16px",
                    borderRadius: "8px",
                    marginBottom: "24px",
                    // border: '1px solid #e0e0e0',
                  }}
                >
                  {/* Heading + Add Button aligned right */}
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "space-between",
                      alignItems: "baseline",
                      marginBottom: 12,
                    }}
                  >
                    <h4 style={{ marginBottom: 0 }}>Bank Details</h4>
                    <Button
                      type="dashed"
                      onClick={() => add()}
                      icon={<PlusOutlined />}
                      size="middle"
                    >
                      Add bank
                    </Button>
                  </div>

                  {/* All bank fields */}
                  {fields.map(({ key, name, ...rest }) => (
                    <Space
                      key={key}
                      align="baseline"
                      style={{ display: "flex", marginBottom: 8 }}
                    >
                      {/* IFSC */}
                      <Form.Item
                        {...rest}
                        name={[name, "ifsc"]}
                        label="IFSC Code"
                        style={{ marginBottom: 0 }}
                        rules={[{ required: true, message: "IFSC required" }]}
                      >
                        <Input
                          placeholder="Enter IFSC code"
                          maxLength={11}
                          onBlur={async (e) => {
                            const ifsc = e.target.value.trim().toUpperCase(); // IFSCs are uppercase
                            if (!ifsc) return;

                            try {
                              const response = await apiRequest({
                                url: "check-ifsc",
                                method: "get",
                                params: { ifsc }, // sent as query param: ?ifsc=XXXX
                              });

                              if (response?.data) {
                                const index =
                                  typeof name === "string"
                                    ? parseInt(name, 10)
                                    : name;
                                form.setFields([
                                  {
                                    name: ["banks", index, "bank_name"],
                                    value: response.data.bankName,
                                  },
                                  {
                                    name: ["banks", index, "address"],
                                    value: response.data.address,
                                  },
                                ]);

                                console.log("name:", name, typeof name);

                                console.log("IFSC valid:", response.data);
                              } else {
                                showError(response?.message || "Invalid IFSC");
                              }
                            } catch (err) {
                              showError("Failed to validate IFSC");
                              console.error(err);
                            }
                          }}
                        />
                      </Form.Item>

                      {/* Bank name  */}
                      <Form.Item
                        {...rest}
                        name={[name, "bank_name"]}
                        label="Bank Name"
                        style={{ marginBottom: 0 }}
                        rules={[{ required: true, message: "Bank name required" }]}
                      >
                        <Input placeholder="Bank name" />
                      </Form.Item>

                      {/* Bank Address */}
                      <Form.Item
                        {...rest}
                        label="Bank Address"
                        name={[name, "address"]}
                        style={{ marginBottom: 0 }}
                      >
                        <Input placeholder="Bank address" />
                      </Form.Item>

                      {/* Account no */}
                      <Form.Item
                        {...rest}
                        name={[name, "acc_no"]}
                        label="Account Number"
                        style={{ marginBottom: 0 }}
                        rules={[
                          { required: true, message: "Account No required" },
                          {
                            validator: (_, value) => {
                              if (!value) return Promise.resolve();

                              const accountNumberRegex = /^[0-9]{9,18}$/;

                              if (!accountNumberRegex.test(value)) {
                                return Promise.reject(
                                  new Error("Account number must be 9 to 18 digits (only numbers)")
                                );
                              }

                              return Promise.resolve();
                            },
                          },
                        ]}
                      >
                        <Input placeholder="Account number" />
                      </Form.Item>


                      {/* Holder Name */}
                      <Form.Item
                        {...rest}
                        name={[name, "holder_name"]}
                        style={{ marginBottom: 0 }}
                        label="Holder Name"
                      >
                        <Input placeholder="Holder Name" />
                      </Form.Item>

                      <MinusCircleOutlined onClick={() => remove(name)} />
                    </Space>
                  ))}
                </div>
              )}
            </Form.List>









            {/* Links */}
            <Form.List name="links">
              {(fields, { add, remove }) => (
                <div
                  style={{
                    background: "#f5f5f5", // full background for whole block
                    padding: "16px",
                    borderRadius: "6px",
                    marginBottom: "24px",
                  }}
                >
                  {/* Header + Add button aligned right */}
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "space-between",
                      alignItems: "baseline",
                      marginBottom: 12,
                    }}
                  >
                    <h4 style={{ marginBottom: 0 }}>Links</h4>
                    <Button
                      type="dashed"
                      onClick={() => add()}
                      icon={<PlusOutlined />}
                      size="middle"
                    >
                      Add link
                    </Button>
                  </div>

                  {/* All link entries */}
                  {fields.map(({ key, name, ...rest }) => (
                    <Space
                      key={key}
                      align="baseline"
                      style={{
                        display: "flex",
                        marginBottom: 8,
                      }}
                    >
                      {/* Link or name */}
                      <Form.Item
                        {...rest}
                        name={[name, "link"]}
                        label="Link or Name"
                        style={{ marginBottom: 0 }}
                        rules={[{ required: true, message: "Link is required" }]}
                      >
                        <Input placeholder="Link or name" />
                      </Form.Item>

                      {/* Description */}
                      <Form.Item
                        {...rest}
                        name={[name, "description"]}
                        label="Description"
                        style={{ marginBottom: 0 }}
                      >
                        <Input placeholder="Description" />
                      </Form.Item>

                      <MinusCircleOutlined onClick={() => remove(name)} />
                    </Space>
                  ))}
                </div>
              )}
            </Form.List>




            {/* documents */}
            <Form.List name="documents">
              {(fields, { add, remove }) => (
                <div
                  style={{
                    background: "#f5f5f5",
                    padding: "16px",
                    borderRadius: "6px",
                    marginBottom: "24px",
                  }}
                >
                  {/* Header + Add button */}
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "space-between",
                      alignItems: "baseline",
                      marginBottom: 12,
                    }}
                  >
                    <h4 style={{ marginBottom: 0 }}>Documents</h4>
                    <Button
                      type="dashed"
                      onClick={() => add()}
                      icon={<PlusOutlined />}
                      size="middle"
                    >
                      Add document
                    </Button>
                  </div>

                  {fields.map(({ key, name, ...rest }) => (
                    <Row gutter={16}>
                      {/* Document Type */}
                      <Col span={8}>
                        <Form.Item
                          name={[name, "document_type"]}
                          label="Document Type"
                          rules={[
                            {
                              required: true,
                              message: "Please select document type",
                            },
                          ]}
                        >
                          <Select allowClear placeholder="Select document type" className="custom-select" style={{ background: "#f5f5f5" }}>
                            <Option value="aadhaar">Aadhaar Card</Option>
                            <Option value="pan">PAN Card</Option>
                            <Option value="10th">10th Certificate</Option>
                            <Option value="12th">12th Certificate</Option>
                            <Option value="graduation">
                              Graduation Certificate
                            </Option>
                            <Option value="other">Other</Option>
                          </Select>
                        </Form.Item>
                      </Col>

                      {/* Document Name */}
                      <Col span={8}>
                        <Form.Item shouldUpdate noStyle>
                          {({ getFieldValue, setFieldsValue }) => {
                            const value =
                              getFieldValue([name, "document_name"]) || "";

                            return (
                              <Form.Item
                                {...rest}
                                name={[name, "document_name"]}
                                label="Document Name"
                                rules={[
                                  {
                                    required: true,
                                    message: "Document name is required",
                                  },
                                  {
                                    pattern: /^[A-Za-z0-9]+$/,
                                    message: "Only alphabets are allowed",
                                  },
                                ]}
                              >
                                <Input
                                  placeholder="Document Name"
                                  maxLength={25}
                                  showCount
                                  value={value}
                                  style={{ background: "#f5f5f5" }}
                                  onChange={(e) => {
                                    // Sirf alphabets allow karo (space, numbers, special chars remove)
                                    let onlyAlphaNum = e.target.value.replace(/[^A-Za-z0-9]/g, "");

                                    // First letter capitalize
                                    if (onlyAlphaNum.length > 0) {
                                      onlyAlphaNum =
                                        onlyAlphaNum.charAt(0).toUpperCase() +
                                        onlyAlphaNum.slice(1);
                                    }

                                    // Field value update karo
                                    setFieldsValue({
                                      documents: {
                                        [name]: {
                                          document_name: onlyAlphaNum,
                                        },
                                      },
                                    });
                                  }}
                                />
                              </Form.Item>
                            );
                          }}
                        </Form.Item>
                      </Col>

                      {/* Upload Document */}
                      <Col span={8}>
                        <Form.Item
                          name={[name, "attachments"]}
                          label="Upload Document (PDF only)"
                          rules={[
                            {
                              required: true,
                              message: "Please upload a document",
                            },
                          ]}
                          valuePropName="fileList"
                          getValueFromEvent={(e) =>
                            Array.isArray(e) ? e : e?.fileList
                          }
                        >
                          <Upload
                            beforeUpload={(file) => {
                              const isPdf = file.type === "application/pdf";
                              if (!isPdf) {
                                Modal.error({
                                  title: "Invalid File Type",
                                  content: "Only PDF files are allowed!",
                                });
                                return Upload.LIST_IGNORE;
                              }
                              return false; // prevent auto-upload
                            }}
                            maxCount={1}
                            style={{ width: "80%" }}
                          >
                            <Button
                              icon={<UploadOutlined />}
                              block
                              style={{
                                height: "80px",
                                fontSize: "16px",
                              }}
                            >
                              Upload PDF
                            </Button>
                          </Upload>
                        </Form.Item>
                      </Col>

                      {/* Remove Button */}
                      <MinusCircleOutlined onClick={() => remove(name)} />
                    </Row>
                  ))}
                </div>
              )}
            </Form.List>

            <div style={{ display: "flex", justifyContent: "flex-end", marginTop: 16 }}>
              <Form.Item>
                <Button
                  type="primary"
                  htmlType="submit"
                  style={{ marginTop: 16 }}
                >
                  {isEditMode ? "Update" : "Add"}
                </Button>
              </Form.Item>
            </div>
          </>
        </Form>
      </Modal>

      <Modal
        visible={previewOpen}
        title={previewTitle}
        footer={null}
        centered
        onCancel={() => setPreviewOpen(false)}
      >
        <img
          alt="Preview"
          style={{ width: '100%' }}
          src={previewImage}
        />
      </Modal>
    </>
  );
};

export default LedgerModal;
